import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (this.props.onError) {
      this.props.onError(error, info);
    }
  }

  handleReset = () => {
    this.setState({ error: null });
    if (this.props.onReset) {
      this.props.onReset();
    }
  };

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="h-screen w-screen flex items-center justify-center bg-surface text-textPrimary p-6">
          <div className="glass-panel w-full max-w-2xl rounded-2xl p-6 space-y-3">
            <p className="text-xs font-semibold text-textMuted">Render error</p>
            <h2 className="text-lg font-semibold text-white m-0">Something crashed</h2>
            <p className="text-sm text-textMuted">
              {error.message || 'Unknown render error.'}
            </p>
            <div className="flex flex-wrap gap-2">
              <button type="button" className="pill-button px-4 py-2" onClick={this.handleReset}>
                Try again
              </button>
            </div>
          </div>
        </div>);

    }

    return this.props.children;
  }
}

export default ErrorBoundary;